import {
  Component, ChangeDetectionStrategy,
} from '@angular/core'

@Component({
  selector: 'kb-panel-content,ng-template[kb-panel-content]',
  templateUrl: './panel-content.component.html',
  styleUrls: ['./panel-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class PanelContentComponent {
}
